import React from 'react';
import { UsersIcon, CheckCircleIcon, AlertTriangleIcon, TrendingUpIcon } from 'lucide-react';
import { DashboardMetrics } from '../types/leads';
interface MetricsBarProps {
  metrics: DashboardMetrics;
}
export function MetricsBar({
  metrics
}: MetricsBarProps) {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-121">
      {/* Total Leads */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 border-l-4 border-l-blue-500 flex items-center justify-between" data-id="element-122">
        <div data-id="element-123">
          <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-124">
            Total Leads Today
          </p>
          <p className="text-3xl font-bold text-gray-900" data-id="element-125">
            {metrics.totalLeads}
          </p>
        </div>
        <div className="h-12 w-12 bg-blue-50 rounded-full flex items-center justify-center" data-id="element-126">
          <UsersIcon className="h-6 w-6 text-blue-600" aria-hidden="true" data-id="element-127" />
        </div>
      </div>

      {/* Successfully Routed */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 border-l-4 border-l-green-500 flex items-center justify-between" data-id="element-128">
        <div data-id="element-129">
          <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-130">
            Successfully Routed
          </p>
          <div className="flex items-baseline space-x-2" data-id="element-131">
            <p className="text-3xl font-bold text-gray-900" data-id="element-132">
              {metrics.successfullyRouted}
            </p>
            <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800" data-id="element-133">
              {metrics.totalLeads > 0 ? Math.round(metrics.successfullyRouted / metrics.totalLeads * 100) : 0}
              %
            </span>
          </div>
        </div>
        <div className="h-12 w-12 bg-green-50 rounded-full flex items-center justify-center" data-id="element-134">
          <CheckCircleIcon className="h-6 w-6 text-green-600" aria-hidden="true" data-id="element-135" />
        </div>
      </div>

      {/* Missing from Lists */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 border-l-4 border-l-red-500 flex items-center justify-between relative overflow-hidden" data-id="element-136">
        <div className="absolute top-0 right-0 -mt-4 -mr-4 h-24 w-24 bg-red-50 rounded-full opacity-50 pointer-events-none" data-id="element-137"></div>
        <div className="relative z-10" data-id="element-138">
          <p className="text-sm font-medium text-red-600 mb-1" data-id="element-139">
            Missing from Lists
          </p>
          <p className="text-3xl font-bold text-red-700" data-id="element-140">
            {metrics.missingFromLists}
          </p>
        </div>
        <div className="relative z-10 h-12 w-12 bg-red-100 rounded-full flex items-center justify-center animate-pulse" data-id="element-141">
          <AlertTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" data-id="element-142" />
        </div>
      </div>

      {/* Success Rate */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 border-l-4 border-l-indigo-500 flex items-center justify-between" data-id="element-143">
        <div className="w-full" data-id="element-144">
          <div className="flex justify-between items-center mb-2" data-id="element-145">
            <p className="text-sm font-medium text-gray-500" data-id="element-146">
              Routing Success Rate
            </p>
            <TrendingUpIcon className="h-5 w-5 text-indigo-500" aria-hidden="true" data-id="element-147" />
          </div>
          <div className="flex items-end space-x-2 mb-2" data-id="element-148">
            <p className="text-3xl font-bold text-gray-900" data-id="element-149">
              {metrics.successRate}%
            </p>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-150">
            <div className={`h-2 rounded-full ${metrics.successRate >= 90 ? 'bg-green-500' : metrics.successRate >= 70 ? 'bg-yellow-500' : 'bg-red-500'}`} style={{
            width: `${metrics.successRate}%`
          }} data-id="element-151"></div>
          </div>
        </div>
      </div>
    </div>;
}